// components/LifeClock.tsx
import { useEffect, useState } from "preact/hooks";

export function LifeClock() {
    const [permission, setPermission] = useState<NotificationPermission>("default");

    useEffect(() => {
        // Request notification permission on component mount
        Notification.requestPermission().then(setPermission);
    }, []);

    const notifyUser = () => {
        if (permission === "granted") {
            const now = new Date();
            const minutes = now.getMinutes();
            const message =
                minutes < 30
                    ? "Time to Execute!"
                    : "Time to Listen, Investigate, and Formulate!";
            new Notification(message);
        }
    };

    const scheduleNotification = () => {
        const now = new Date();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();

        // Calculate time until the next half-hour mark
        let delay = (30 - (minutes % 30)) * 60 * 1000 - seconds * 1000;

        setTimeout(() => {
            notifyUser();
            scheduleNotification(); // Schedule the next notification
        }, delay);
    };

    useEffect(() => {
        // Schedule the initial notification
        if (permission === "granted") {
            scheduleNotification();
        }
    }, [permission]);

    const [currentTime, setCurrentTime] = useState<Date>(new Date());


    // Separate effect for time updates
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); // Update every second

        return () => clearInterval(timer);
    }, []);



    const minutes = currentTime.getMinutes();
    const seconds = currentTime.getSeconds();
    const remainingMinutes = minutes < 30.0 ? 29.0 - minutes : 59.0 - minutes;
    const remainingSeconds = 59.0 - seconds;
    const phase = minutes > 30.0 ? "Execute" : "Listen, Investigate, Formulate";

    return (
        <div className="life-clock">
            {/* Display notification status */}
            {/*<p>Notification permission: {permission}</p>*/}
            {/* Button to request permission (if needed) */}
            {permission === "default" && (
                <button
                    className="btn"
                    onClick={() =>
                        Notification.requestPermission().then(setPermission)
                    }
                >
                    Request Permission
                </button>
            )}

            <div className="digital-clock">
                <h1 className="digital-clock__title">{phase}</h1>
                {/*<span className="phase"></span>*/}
                <span className="time">
          {remainingMinutes.toString().padStart(2, "0")}:
                    {remainingSeconds.toString().padStart(2, "0")}
        </span>
            </div>



            <style jsx>{`
                .life-clock {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .digital-clock {
                    font-size: 24px;
                    font-weight: bold;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .phase {
                    font-size: 18px;
                    margin-bottom: 5px;
                }

                .time {
                    font-size: 36px;
                }

                .btn {
                    padding: 8px 16px;
                    background-color: #2196f3;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-bottom: 10px; /* Add margin to separate the button */
                }

                textarea {
                    width: 100%;
                    height: 80px;
                    padding: 10px;
                    margin-bottom: 10px;
                    border: 1px solid #ccc;
                    resize: vertical;
                }
            `}</style>
        </div>
    );
}

export function LogEntry() {
    const [logEntry, setLogEntry] = useState("");
    const [dailyLogs, setDailyLogs] = useState<{ [date: string]: string[] }>({});
    useEffect(() => {
        // Load logs from localStorage on component mount
        const storedLogs = localStorage.getItem("lifeClockLogs");
        if (storedLogs) {
            setDailyLogs(JSON.parse(storedLogs));
        }
    }, []);

    const handleLogEntryChange = (event: any) => {
        setLogEntry(event.target.value);
    };

    const addLogEntry = () => {
        const now = new Date();
        const dateKey = now.toLocaleDateString();
        const updatedLogs = { ...dailyLogs };

        if (updatedLogs[dateKey]) {
            updatedLogs[dateKey].push(logEntry);
        } else {
            updatedLogs[dateKey] = [logEntry];
        }

        setDailyLogs(updatedLogs);
        setLogEntry("");

        // Save logs to localStorage
        localStorage.setItem("lifeClockLogs", JSON.stringify(updatedLogs));
    };

    return(
        <>
            {/* Log Entry Input */}
            <div >
        <textarea
            value={logEntry}
            onChange={handleLogEntryChange}
            placeholder="Write your log entry..."
        />
                <button className="btn" onClick={addLogEntry}>
                    Add Log
                </button>
            </div>

            {/* Display Daily Logs */}
            <h2>Daily Logs</h2>
            <ul>
                {Object.entries(dailyLogs).map(([date, entries]) => (
                    <li key={date}>
                        <h3>{date}</h3>
                        <ul>
                            {entries.map((entry, index) => (
                                <li key={index}>{entry}</li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        </>
    )
}
